/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { referralsGetResponseSchema } from './referralsGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getReferrals200Schema = z.lazy(() => referralsGetResponseSchema);

/**
 * @description 505 response
 */
export const getReferrals505Schema = z.any();

export const getReferralsQueryResponseSchema = z.lazy(() => getReferrals200Schema);
